import { render, staticRenderFns } from "./ImageCreate.vue?vue&type=template&id=67a23fe3&scoped=true&"
import script from "./ImageCreate.vue?vue&type=script&lang=js&"
export * from "./ImageCreate.vue?vue&type=script&lang=js&"
import style0 from "./ImageCreate.vue?vue&type=style&index=0&id=67a23fe3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a23fe3",
  null
  
)

export default component.exports